import React, { Fragment } from 'react';
// @ts-ignore
import { Router } from '../configs/routes';
import withAppLayout from '../components/appLayout';
import Modal from '../components/modal';
import cx from 'classnames';
import {
  buckets,
  Direction,
  makeid,
  CDN_CLRSAVE_URL,
  accordionItems,
  accordionItemsForVariant,
  RECOMMENDED_ARTICLES,
} from '../constants';
import { COPY_DATA } from '../constants/plan/copyData';
import { getNextDates, generateCartItems } from '../utils/cartUtils';
import {
  splitInvestments,
  roundOffTo500,
  getSuggestedAmountSafely,
  scrollToTargetById,
  debounce,
} from '../utils/commonUtils';
import { Api } from '../api';
import { redirectToLoginPage, showError } from '../utils';

import styles from '../styles/homePage/planV2.scss';
import { trackAction, trackPixel } from '../utils/trackActions';
import { createActivity } from '../utils/leadUtils';
import {
  getSubHeading,
  handleBackNavigation,
  disableBackButton,
  handleBackAction,
} from '../utils/paymentModalUtils';
import PlanSummary from '../components/plan/planSummary';
import CustomerReveiws from '../components/plan/customerReveiws';
import RecommendedPlans from '../components/plan/recommendedPlans';
import FAQ from '../components/plan/faq';
import FundSummary from '../components/plan/fundSummary';
import WhyCleartax from '../components/plan/whyCleartax';
import { stringify, parse } from 'query-string';
import RelatedArticle from '../components/plan/relatedArticle';
import { VARIANT_KEY, VARIANT_VALUES } from '../constants/variantConstants';
import { Accordion } from '../components/ui/accordian/accordian';
import { AccordionSection } from '../components/ui/accordian/accordianSection';
import AccordianSectionHeader from '../components/ui/accordian/accordianSectionHeader';
import AccordianSectionBody from '../components/ui/accordian/accordianSectionBody';
import InvestmentCard from '../components/plan/investmentCard';
import EstimateReturnCalculator from '../components/plan/estimateReturnCalculator';
import PlanReturnGraph from '../components/f2s/planReturnGraph';
import SectionHeader from '../components/plan/sectionHeader';
import FundItem from '../components/plan/fundItem';
import InvestFlowView from '../components/invest/investFlowView';
import Header from '../components/nextHead';
import MandateFlowView from '../components/mandate/mandateFlowView';
import PennyDropView from './../components/common/pennyDropView';
import OtpModal from '../components/dashboard/otpModal';

const api = new Api();
interface Props {
  handleNavigation?(slug: string, to: string, event?: any): void;
  url: any;
  bucketData: any; // TODO define type model
  entity?: any;
  userInfo: any;
  isMobile: boolean;
  pendingActions: any;
}

interface State {
  planData: any;
  id: string;
  isVariant: boolean;
  investmentType: Direction;
  amount: number;
  date: string;
  editing: boolean;
  cart: any;
  removedFunds: any;
  disableButton: boolean;
  detailsSlug: string;
  supportedInvesmtendModes: Direction[];
  callbackRequested: boolean;
  ratings: string;
  showStickyInvestBtn: boolean;
  callbackEmail: string;
  callbackMobile: string;
  isValidEmail: boolean;
  isValidMobile: boolean;
  pennyDropInitiated: boolean;
  bankAccountStatus: any;
  userDetails: any;
  bankErrorMsg: string;
  isTimeOut: boolean;
  isBankVerified: boolean;
  pendingActions: any;
  scheduleLater: boolean;
  otpScreen: boolean;
  otp: string;
  otpEmail: string;
  otpPhone: string;
  isOtpWrong: boolean;
  isOtpVerified: boolean;
  verifyOtpLoader: boolean;
  investmentToken: string;
}

class PlanDetails extends React.Component<Props, State> {
  private modal: any;
  constructor(props: Props) {
    super(props);
    this.state = this.generateInitialState(props);
  }

  private generateInitialState = (props: Props) => {
    const {
      id,
      amount,
      investmentType = Direction.SIP,
      removedFunds,
      [VARIANT_KEY]: variant,
    } = props.url.query;
    const isVariant = variant === VARIANT_VALUES.A;
    const { products = [] } = props.bucketData || {};
    const filteredProducts = removedFunds
      ? products.filter(
          (item: any) => removedFunds.indexOf(item.productId) === -1
        )
      : products;
    const supportedInvesmtendModes = this.getSupportedInvestmentMode();
    const preferredInvestmentMode = Direction.SIP;
    const suggestedTypeThere =
      supportedInvesmtendModes.indexOf(investmentType) > -1;
    const initialInvestmentMode = suggestedTypeThere
      ? investmentType
      : preferredInvestmentMode;
    const isSIP = initialInvestmentMode === Direction.SIP;
    const hasUserInvestedInProduct = false;
    const suggestedAmount = getSuggestedAmountSafely(
      props.bucketData,
      isSIP,
      'minSipAmountForBucket',
      'minAmountForBucket',
      hasUserInvestedInProduct,
      amount
    );
    const cart = splitInvestments(
      suggestedAmount,
      filteredProducts,
      initialInvestmentMode
    );

    return {
      planData: buckets.filter((bucket) => bucket.bucketId === id),
      id,
      isVariant,
      investmentType: initialInvestmentMode,
      date: getNextDates()[0].toDateString(),
      amount: suggestedAmount,
      cart,
      editing: false,
      removedFunds: JSON.parse(removedFunds || '[]'),
      disableButton: false,
      detailsSlug: props.url.query.detailsSlug,
      supportedInvesmtendModes,
      callbackRequested: false,
      ratings: '',
      showStickyInvestBtn: false,
      callbackEmail: '',
      callbackMobile: '',
      isValidEmail: true,
      isValidMobile: true,
      pennyDropInitiated: false,
      bankAccountStatus: '',
      userDetails: {},
      bankErrorMsg: '',
      isTimeOut: false,
      isBankVerified: false,
      pendingActions: props.pendingActions || [],
      scheduleLater: false,
      otpScreen: false,
      otp: '',
      otpEmail: '',
      otpPhone: '',
      isOtpWrong: false,
      isOtpVerified: false,
      verifyOtpLoader: false,
      investmentToken: '',
    };
  };

  private scheduleModal = () => {
    this.setState({
      scheduleLater: true,
    });
  };

  private dissmissScheduleModal = () => {
    this.setState({
      scheduleLater: false,
    });
  };
  private getSupportedInvestmentMode() {
    let supportedInvesmtendModes = [];
    const { sipSupported = true, lumpSumSupported = true } =
      this.props.bucketData || {};
    if (sipSupported) {
      supportedInvesmtendModes.push(Direction.SIP);
    }
    if (lumpSumSupported) {
      supportedInvesmtendModes.push(Direction.LUMPSUM);
    }
    if (!sipSupported && !lumpSumSupported) {
      supportedInvesmtendModes = [Direction.SIP, Direction.LUMPSUM];
    }
    return supportedInvesmtendModes;
  }

  public UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const {
      id: oldId,
      detailsSlug: oldDetailsSlug,
      amount: oldAmount,
      investmentType: oldType,
    } = this.props.url.query;
    const { id, detailsSlug, amount, investmentType } = nextProps.url.query;

    // reload state if any of these changed
    if (id !== oldId || amount !== oldAmount || investmentType !== oldType) {
      this.setState(this.generateInitialState(nextProps));
    }
    if (detailsSlug !== oldDetailsSlug) {
      this.setState({ detailsSlug });
    }
    if (nextProps.pendingActions !== this.state.pendingActions) {
      this.setState({
        pendingActions: nextProps.pendingActions,
      });
    }
  }

  public async componentDidUpdate() {
    const { userInfo } = this.props;
    if (userInfo) {
      const res = await api.getPendingActions();
      if (
        res &&
        JSON.stringify(res.response) !==
          JSON.stringify(this.state.pendingActions)
      ) {
        this.setState({
          pendingActions: res.response,
        });
      }
    }
  }

  public async componentDidMount() {
    const { isMobile } = this.props;
    if (isMobile) {
      window.addEventListener(
        'scroll',
        debounce(this.handleStickyInvestBtn, 50)
      );
    }
    const { id, planData, cart } = this.state;
    const { userInfo } = this.props;
    const { email: callbackEmail = '', phoneNumber: callbackMobile = '' } =
      userInfo || {};
    const planItem = planData[0] || {};
    const title = planItem.title || (cart[0] || {}).fundName;
    const {
      url: {
        query: { startPayment },
      },
    } = this.props;
    const { query } = this.props.url;
    const { detailsSlug, investmentType, amount, ...queryObj } = query;
    if (amount) {
      Router.pushRoute('plan', queryObj);
    }

    if (userInfo) {
      this.setState({
        callbackEmail,
        callbackMobile,
      });
    }

    createActivity({
      ActivityEvent: 205,
      ActivityNote: 'Plan Viewed',
      EmailAddress: callbackEmail,
      Fields: [
        {
          SchemaName: 'mx_Custom_1',
          Value: title,
        },
      ],
    });
    trackPixel('ViewContent', {
      content_type: 'bucket',
      value: id,
    });
    if (startPayment === '1') {
      this.handleStartPaymentFromURL();
    }
  }

  private handleStartPaymentFromURL = async () => {
    this.investClick();
  };

  private dismissModal = () => {
    const { query } = this.props.url;
    // while closing modal try to retails the amount and invest type query params
    const { detailsSlug, startPayment, sipDate, ...queryObj } = query;
    Router.pushRoute('plan', queryObj);
    this.setState({ disableButton: false, otpScreen: false });
  };

  public investClick = async (e?: any) => {
    if (e) {
      e.preventDefault();
    }
    const { amount, cart, id, investmentType, planData } = this.state;
    const planItem = planData[0] || {};
    const title = planItem.title || (cart[0] || {}).fundName;
    trackAction('invest-plan', investmentType, title, amount);
    createActivity({
      ActivityEvent: 206,
      ActivityNote: 'Plan Selected',
      Fields: [
        {
          SchemaName: 'mx_Custom_1',
          Value: title,
        },
        {
          SchemaName: 'mx_Custom_2',
          Value: amount,
        },
        {
          SchemaName: 'mx_Custom_3',
          Value: investmentType,
        },
      ],
    });
    new Api()
      .updateCart(
        generateCartItems(cart, investmentType),
        'plan',
        planItem.bucketId
      )
      .then(() => {
        trackPixel('AddToCart', {
          content_type: 'bucket',
          value: id,
        });
        const { userInfo, url } = this.props;
        const {
          query: { startPayment },
        } = url;
        // trying to get rid of window dependancy, read from props instead
        if (userInfo) {
          // when invest click retain the previous query params
          // this is load the page with initial state when modal closed
          const detailsSlug = startPayment === '1' ? 'payment' : 'first';
          Router.pushRoute('plan', {
            ...url.query,
            id,
            detailsSlug,
          });
        } else {
          redirectToLoginPage();
        }
      });
  };

  public getMinAmount = (investmentType: string, cart: any[]) => {
    const minAmountObj = cart.reduce(
      (acc, item) => {
        return {
          minLumpsumAmount: item.minAmount + acc.minLumpsumAmount,
          minSipAmount: item.minSipAmount + acc.minSipAmount,
        };
      },
      { minSipAmount: 0, minLumpsumAmount: 0 }
    );

    const { minSipAmount, minLumpsumAmount } = minAmountObj;
    const isSip = investmentType === Direction.SIP;
    const minAmount = isSip ? minSipAmount : minLumpsumAmount;
    return minAmount;
  };

  public onAmountChangeBlur = (e: any) => {
    // Round off the amount by 500 and update local store
    const value = parseInt(e.target.value.replace(/\D/g, ''), 10);
    let totalAmount = roundOffTo500(value);
    const { investmentType } = this.state;
    const minAmount = this.getMinAmount(investmentType, this.state.cart);
    if (totalAmount < minAmount) {
      totalAmount = minAmount;
    }
    const cart = splitInvestments(totalAmount, this.state.cart, investmentType);
    const queries = parse(location.search);
    queries.amount = totalAmount;
    Router.pushRoute(`${location.pathname}?${stringify(queries)}`, {
      shallow: true,
    });
    this.setState({
      amount: totalAmount,
      cart,
    });
  };

  public handleInvestmentTypeChange = (amount: number, type: Direction) => {
    const { cart } = this.state;
    const queries = parse(location.search);
    const newCart = splitInvestments(amount, cart, type);
    queries.investmentType = type;
    queries.amount = amount;

    Router.pushRoute(`${location.pathname}?${stringify(queries)}`, {
      shallow: true,
    });
    this.setState({
      amount,
      cart: newCart,
      investmentType: type,
    });
  };

  private onEditFunds = () => {
    this.modal.dismiss();
    this.dismissModal();
  };

  private renderAccordian = (value: string) => {
    const { amount } = this.state;
    const { bucketData = {} } = this.props;
    const { planSummaryReasons, planSummary, faqs, otherPlans } =
      bucketData.sections;
    switch (value) {
      case 'estimate-returns':
        return (
          <Fragment>
            <EstimateReturnCalculator
              bucketDetails={bucketData}
              invAmount={amount}
            />
          </Fragment>
        );

      case 'summary':
        return planSummary && planSummaryReasons ? (
          <PlanSummary
            data={planSummary}
            reasons={planSummaryReasons}
            showTitle={false}
          />
        ) : null;

      case 'fund-summary':
        return (
          <Fragment>
            <FundSummary data={bucketData.products} showTitle={false} />
          </Fragment>
        );

      case 'customer-reviews':
        return <CustomerReveiws />;

      case 'why-cleartax':
        return <WhyCleartax showTitle={false} />;

      case 'recommended':
        return (
          <Fragment>
            {otherPlans && (
              <RecommendedPlans
                funds={otherPlans.plans.slice(0, 2)}
                showTitle={false}
              />
            )}
          </Fragment>
        );

      case 'related-articles':
        return (
          <Fragment>
            {planSummary.elssTable ? (
              <Fragment>
                {RECOMMENDED_ARTICLES.map((article, index) => (
                  <div className="large-4 columns pl0 mb20" key={index}>
                    <RelatedArticle article={article} />
                  </div>
                ))}
              </Fragment>
            ) : null}
          </Fragment>
        );

      case 'faq':
        return (
          <Fragment>
            {faqs ? <FAQ faqs={faqs.faqs} showTitle={false} /> : null}
          </Fragment>
        );
    }
  };

  private onEditAmount = () => {
    const {
      url: { pathname },
      bucketData: {
        sections: { bucketId },
      },
    } = this.props;
    const path = `/save${pathname}/${bucketId}`;
    Router.pushRoute(path, path, { shallow: true });
  };

  public changeState = (key: any, value: any) => {
    /** this is to track fund selection */
    if (key === 'editing' && value === true) {
      createActivity({ ActivityEvent: 191, ActivityNote: 'fund selection' });
    } else {
      const queries = parse(location.search);
      if (this.state.removedFunds.length) {
        queries.removedFunds = JSON.stringify(this.state.removedFunds);
      } else {
        delete queries.removedFunds;
      }
      Router.pushRoute(`${location.pathname}?${stringify(queries)}`, {
        shallow: true,
      });
    }
    this.setState({
      [key]: value,
    });
  };

  public deleteFund = (e: any, id: number, fundName: string) => {
    e.preventDefault();
    e.stopPropagation();
    trackAction('delete-fund', 'plan-details-edit-funds', fundName);
    const { amount, cart, removedFunds, investmentType } = this.state;

    const newCart = cart.filter((item) => id !== item.productId);
    const newCartSplit = splitInvestments(amount, newCart, investmentType);

    this.setState({
      cart: newCartSplit,
      removedFunds: removedFunds.concat(id),
    });
  };

  public addBackFund = (e: any, id: number, fundName: string) => {
    e.preventDefault();
    e.stopPropagation();
    trackAction('add-back-fund', 'plan-details-edit-funds', fundName);
    const { amount, cart, removedFunds, investmentType } = this.state;

    const newCart = cart.concat(
      this.props.bucketData.products.filter((fund) => fund.productId === id)
    );

    const minAmount = this.getMinAmount(investmentType, newCart);
    let newAmount = amount;
    if (newAmount < minAmount) {
      newAmount = minAmount;
    }

    const newCartSplit = splitInvestments(newAmount, newCart, investmentType);

    this.setState({
      cart: newCartSplit,
      removedFunds: removedFunds.filter((fund) => fund !== id),
      amount: newAmount,
    });
  };

  private handleStickyInvestBtn = () => {
    const { showStickyInvestBtn } = this.state;
    // if condition prevent from unnecessery rendering
    if (showStickyInvestBtn && window && window.pageYOffset < 577) {
      this.setState({
        showStickyInvestBtn: false,
      });
    } else if (!showStickyInvestBtn && window && window.pageYOffset > 577) {
      this.setState({
        showStickyInvestBtn: true,
      });
    }
  };

  // Function for penny drop
  public async doPennyDrop(requestObj: any, cb?: any) {
    const { accountNo, ifscCode, cityOfBank, nameOfBank, branchName } =
      requestObj.userBankDetails;
    const bankDetails = {
      accountNo,
      ifscCode,
      cityOfBank,
      nameOfBank,
      branchName,
    };
    let pennyStatusInterval;

    const isTimeoutForPd = setTimeout(() => {
      this.setState({ isTimeOut: true });
      clearInterval(pennyStatusInterval);
    }, 90000);

    const applyPennyDropStatus = () => {
      const { bankAccountStatus } = this.state;
      if (bankAccountStatus.length > 0) {
        clearInterval(pennyStatusInterval);
        clearTimeout(isTimeoutForPd);
      }
      if (bankAccountStatus === 'ACTIVE') {
        setTimeout(() => {
          this.setState(
            { pennyDropInitiated: false, isBankVerified: true },
            () => {
              if (cb) {
                cb(true);
              }
            }
          );
        }, 3000);
      }
    };

    const initPennyResp = await api.initializePennyDrop(bankDetails);

    if (initPennyResp && initPennyResp.success) {
      this.setState(
        {
          pennyDropInitiated: true,
          userDetails: requestObj,
          bankErrorMsg: '',
          bankAccountStatus: '',
        },
        () => {
          pennyStatusInterval = setInterval(async () => {
            const statusResp = await api.getPennyDropStatus(
              accountNo,
              ifscCode
            );
            if (!statusResp.bankAccountStatus) {
              return;
            }
            this.setState(
              {
                bankAccountStatus: statusResp.bankAccountStatus,
              },
              applyPennyDropStatus
            );
          }, 5000);
        }
      );
    } else if (
      initPennyResp &&
      initPennyResp.errorDTO &&
      initPennyResp.errorDTO.message
    ) {
      this.setState({
        bankErrorMsg: initPennyResp.errorDTO.message,
        pennyDropInitiated: false,
      });
    }
  }

  public handleChangeDetails = () => {
    this.setState({
      bankAccountStatus: '',
      pennyDropInitiated: false,
      isTimeOut: false,
    });
  };

  private showOtpScreen = async () => {
    this.setState(
      {
        otpScreen: true,
      },
      () => {
        this.generateOtp('NEW_OTP');
      }
    );
  };

  private handleOtpChange = (otp: string) => {
    this.setState({ otp });
  };

  private generateOtp = async (requestType: string) => {
    const { cart } = this.state;
    // const isInstantRedemption =
    //   this.state.redemptionType === INSTANT_REDEMPTION;
    if (cart) {
      try {
        const productIds = cart.map((item) => item.productId) || [];
        const payload = {
          otpRequestType: requestType,
          productIds,
        };
        const res = await api.handleInvestmentOtp(payload, false);
        if (res) {
          if (res.otpStatus === 'OTP_GENERATION_FAILED') {
            showError(res.description);
          } else if (
            res.otpStatus === 'OTP_GENERATED' ||
            res.otpStatus === 'OTP_REGENERATED'
          ) {
            const { email, phone } = res;
            this.setState({
              otpEmail: email,
              otpPhone: phone,
              isOtpWrong: false,
              otp: '',
            });
          }
        }
      } catch (err) {
        showError(err);
      }
    }
  };

  private verifyOtp = async () => {
    const { cart, otp } = this.state;
    if (cart) {
      this.setState({
        verifyOtpLoader: true,
      });
      try {
        const productIds = cart.map((item) => item.productId) || [];
        const payload = {
          otpRequestType: 'VERIFY_OTP',
          productIds,
          otp,
        };
        const res = await api.handleInvestmentOtp(payload, true);
        if (res) {
          if (res.otpStatus === 'VERIFICATION_FAILED') {
            this.setState({
              verifyOtpLoader: false,
            });
            if (res.otpError === 'WRONG_OTP') {
              this.setState({ isOtpWrong: true });
            } else {
              showError(res.otpError);
            }
          } else if (res.otpStatus === 'VERIFICATION_SUCCEED') {
            this.setState({
              otpScreen: false,
              isOtpVerified: true,
              investmentToken: res.investmentToken,
            });
          }
        }
      } catch (err) {
        showError(err);
      }
    }
  };
  public render() {
    const [data = {}] = this.state.planData;
    const {
      detailsSlug,
      planData,
      editing,
      cart,
      isVariant,
      removedFunds,
      showStickyInvestBtn,
      investmentType,
      id,
      amount,
      pennyDropInitiated,
      bankAccountStatus,
      userDetails,
      bankErrorMsg,
      isTimeOut,
      isBankVerified,
      scheduleLater,
      isOtpVerified,
      otp,
      otpEmail,
      otpPhone,
      otpScreen,
      isOtpWrong,
      verifyOtpLoader,
      investmentToken,
    } = this.state;
    const { bucketId } = planData[0];
    const {
      bucketData = {},
      entity,
      url,
      userInfo,
      pendingActions,
    } = this.props;
    const isBankPending =
      pendingActions.indexOf('OPS_APPROVAL_PENDING_FOR_BANK_DETAILS') !== -1
        ? true
        : false;

    const isPennyDropPending = this.state.pendingActions.includes(
      'PENNY_DROP_NOT_DONE'
    );

    const alreadyInvested = userInfo ? userInfo.alreadyInvested : false;
    const { planSummary } = bucketData.sections;
    const isPaymentMode = detailsSlug === 'payment';
    const modalTitle = 'Complete Your Investment';
    const showEditButton = data.funds
      ? data.funds.funds.length > 1 && cart.length >= 1
      : false;
    const { products: allFunds = [] } = bucketData || {};
    const accordions = isVariant ? accordionItemsForVariant : accordionItems;
    const pageData = COPY_DATA[bucketId];
    let pageTitle =
      'Mutual Funds Investment India - Save Taxes &amp; Grow Wealth Online - ClearTax Invest';
    const pageDescription =
      'ClearTax Invest helps you to Invest in the best performing funds in 2021 & let your money grow through the power of compounding. Start your investment journey today!';
    if (bucketId === '19') {
      pageTitle = 'ClearTax Invest - Tax-Saver Plan';
    } else if (bucketId === '21') {
      pageTitle = 'ClearTax Invest - Quick Savings Plan';
    }

    return (
      <div>
        <div className="row mb30 mt30">
          <div
            className={cx(
              styles['sticky-top-desktop'],
              'columns large-4 mb30 float-right-force'
            )}
          >
            <div className={cx(styles['heading-section'], 'mb15 mobile-only')}>
              <div>
                <h4 className="mb5">{pageData.title}</h4>
                <div className={cx(styles['tags'])}>
                  {pageData.chips.map((chip: string, i: number) => {
                    return (
                      <div className="text--sm font--fadedgrey" key={i}>
                        {chip}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className={cx(styles['user-container'], 'mb15')}>
              <div className="mr15">
                {pageData.investorProfile.userInfo.map((user, i) => {
                  return (
                    <img key={i} src={user.imgURL} alt="user" width="35" />
                  );
                })}
              </div>
              <div>
                + <strong>{pageData.investorProfile.userInvested}</strong>{' '}
                Investors
              </div>
            </div>
            <InvestmentCard
              minAmount={this.getMinAmount(investmentType, cart)}
              title="Start your investment"
              bucketData={bucketData}
              investClick={this.investClick}
              onAmountChangeBlur={this.onAmountChangeBlur}
              handleInvestmentTypeChange={this.handleInvestmentTypeChange}
              isVariant={isVariant}
            />
          </div>
          <div className="columns large-8">
            <div className={cx(styles['heading-section'], 'mb15 desktop-only')}>
              <div>
                <h4 className="mb5">{pageData.title}</h4>
                <div className={cx(styles['tags'])}>
                  {pageData.chips.map((chip: string, i: number) => {
                    return (
                      <div className="text--sm font--fadedgrey" key={i}>
                        {chip}
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="mb20">
              <PlanReturnGraph
                bucketDetails={bucketData}
                url={url}
                showYaxis={false}
                hideTitle={true}
              />
            </div>
            <div className="bold text--large line-height mb15">
              {pageData.subTitle}
            </div>
            <div className="font--grey line-height mb30">
              {pageData.description}
            </div>
            <div className="row mb30">
              <div
                className={cx(styles['benefits'], 'columns large-6 medium-6')}
              >
                <img
                  src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/1563285785_stopwatch.svg`}
                  width="45"
                  alt=""
                />
                <div className="pl10">
                  <div className="mb5 bold">{pageData.lockIn.title}</div>
                  <div className="text--normal">
                    {pageData.lockIn.description}
                  </div>
                </div>
              </div>
              <div
                className={cx(styles['benefits'], 'columns large-6 medium-6')}
              >
                <img
                  src={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/1563285746_money.svg`}
                  width="45"
                  alt=""
                />
                <div className="pl10">
                  <div className="mb5 bold">{pageData.returns.title}</div>
                  <div className="text--normal">
                    {pageData.returns.description}
                  </div>
                </div>
              </div>
            </div>
            {pageData.note ? (
              <div className="row mb30">
                <div className="font--grey line-height">
                  <i>{pageData.note}</i>
                </div>
              </div>
            ) : null}
            <div className="row ml0 mr0">
              <div className="border-bottom mb40 pb20">
                <div>
                  {editing ? (
                    <SectionHeader
                      title="Funds in this plan"
                      action={
                        showEditButton
                          ? {
                              text: 'Done',
                              onClick: () =>
                                this.changeState('editing', !editing),
                            }
                          : null
                      }
                    />
                  ) : (
                    <SectionHeader
                      title="Funds in this plan"
                      action={
                        showEditButton
                          ? {
                              text: 'Edit Funds',
                              onClick: () =>
                                this.changeState('editing', !editing),
                            }
                          : null
                      }
                    />
                  )}
                </div>
                <div className={cx('pb20 clearboth')}>
                  <div className={styles['funds-table']}>
                    <div className={cx('clearboth', styles['table-head'])}>
                      <div className="large-8 small-7 columns">
                        <span
                          className={cx(
                            'text--sm font--grey font--bold mt10 mb10 block'
                          )}
                        >
                          FUND
                        </span>
                      </div>
                      <div className="large-4 small-5 columns">
                        <div className="row">
                          <div className="large-6 small-6 columns">
                            <span
                              className={cx(
                                'text--sm font--grey font--bold mt10 mb10 block'
                              )}
                            >
                              {isVariant ? (
                                <span>3Y Return</span>
                              ) : (
                                <span>
                                  Return
                                  <br />
                                  <small>3 Year Average</small>
                                </span>
                              )}
                            </span>
                          </div>

                          <div className="large-6 small-6 columns right-align">
                            <span
                              className={cx(
                                'text--sm font--grey font--bold mt10 mb10 block'
                              )}
                            >
                              {isVariant ? (
                                <span>5Y Return</span>
                              ) : (
                                <span>
                                  Return
                                  <br />
                                  <small>5 Year Average</small>
                                </span>
                              )}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ul className="mb0">
                      {cart.map((fund) => (
                        <FundItem
                          key={makeid()}
                          _length={cart.length}
                          fund={fund}
                          isVariant={isVariant}
                          editing={editing}
                          disabledClass=""
                          removed={false}
                          changeFund={this.deleteFund}
                        />
                      ))}
                    </ul>
                    <ul className="mb0">
                      {allFunds
                        .filter(
                          (fund) => removedFunds.indexOf(fund.productId) !== -1
                        )
                        .map((fund) => (
                          <FundItem
                            key={makeid()}
                            _length={allFunds.length}
                            fund={fund}
                            isVariant={isVariant}
                            editing={editing}
                            disabledClass={styles['disabled-fund']}
                            removed={true}
                            changeFund={this.addBackFund}
                          />
                        ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div>
              {accordions.map((item, i) => {
                return item.value === 'related-articles' &&
                  !planSummary.elssTable ? null : (
                  <Accordion type="custom" key={i} selected="estimate-returns">
                    <AccordionSection id={item.value}>
                      <AccordianSectionHeader>
                        <span>{item.label}</span>
                      </AccordianSectionHeader>
                      <AccordianSectionBody className="ml10">
                        <span>{this.renderAccordian(item.value)}</span>
                      </AccordianSectionBody>
                    </AccordionSection>
                  </Accordion>
                );
              })}
            </div>
          </div>
        </div>
        {showStickyInvestBtn ? (
          <div className={cx(styles['sticky-bottom-mobile'])}>
            <button
              className="btn-full btn-green-solid btn-small text--lg"
              onClick={() => scrollToTargetById('investment-card')}
            >
              INVEST NOW
            </button>
          </div>
        ) : null}

        {detailsSlug ? (
          <div>
            {!isBankPending ? (
              <Modal
                {...this.props}
                fullScreen
                // maxWidth={isPaymentMode ? '1000px' : ''}
                subHeadingMessage={
                  pennyDropInitiated
                    ? ''
                    : otpScreen
                    ? 'Verify yourself'
                    : scheduleLater
                    ? 'Schedule order'
                    : getSubHeading(detailsSlug)
                }
                title={
                  scheduleLater ? 'Schedule order to pay later' : modalTitle
                }
                ref={(modal: any) => (this.modal = modal)}
                onDismiss={this.dismissModal}
                onUnmount={this.dismissModal}
                headerPad={30}
                handleBack={() => handleBackAction(detailsSlug)}
                disableBackButton={
                  pennyDropInitiated || otpScreen
                    ? true
                    : disableBackButton(detailsSlug, alreadyInvested)
                }
              >
                {pennyDropInitiated ? (
                  <PennyDropView
                    bankAccountStatus={bankAccountStatus}
                    userDetails={userDetails}
                    handleChangeDetails={this.handleChangeDetails}
                    dismissModal={this.dismissModal}
                    isTimeOut={isTimeOut}
                  />
                ) : otpScreen ? (
                  <OtpModal
                    otp={otp}
                    handleOtpChange={this.handleOtpChange}
                    phone={otpPhone}
                    email={otpEmail}
                    verifyOtp={this.verifyOtp}
                    generateOtp={this.generateOtp}
                    isOtpWrong={isOtpWrong}
                    numOfInputs={6}
                    verifyOtpLoader={verifyOtpLoader}
                  />
                ) : (
                  <InvestFlowView
                    bankDetails={entity.userBankDetails}
                    personalDetails={entity.userPersonalDetails}
                    hideEdit={alreadyInvested}
                    parentProps={{ ...this.props }}
                    investmentType={investmentType}
                    handleEditAmount={this.onEditAmount}
                    onEditFunds={this.onEditFunds}
                    hideEditFunds={false}
                    onEdit={this.onEditFunds}
                    isPaymentMode={isPaymentMode}
                    url={url}
                    handleBack={() => {
                      return handleBackNavigation(detailsSlug);
                    }}
                    doPennyDrop={(bankDetails, cb) =>
                      this.doPennyDrop(bankDetails, cb)
                    }
                    bankErrorMsg={bankErrorMsg}
                    isBankVerified={isBankVerified}
                    scheduleLater={scheduleLater}
                    scheduleModal={this.scheduleModal}
                    dissmissScheduleModal={this.dissmissScheduleModal}
                    dismissModal={this.dismissModal}
                    pennyDropPending={isPennyDropPending}
                    isOtpVerified={isOtpVerified}
                    showOtpScreen={this.showOtpScreen}
                    investmentToken={investmentToken}
                  />
                )}
              </Modal>
            ) : (
              <Modal
                title="Documents under review"
                maxWidth=""
                disableBackButton={true}
                onDismiss={this.dismissModal}
                onUnmount={this.dismissModal}
              >
                <div className="pl30 pr30">
                  Dear Investor,
                  <br />
                  <br />
                  Your uploaded documents are currently under review. You can
                  start investing as soon as the documents are verified. Our
                  support team will update the status in next 24-48 hours.
                  Thanks for your patience!
                </div>
              </Modal>
            )}
          </div>
        ) : null}
        <MandateFlowView
          investmentType={investmentType}
          amount={amount}
          url={url}
        />
        <Header
          title={pageTitle}
          description={pageDescription}
          canonicalUrl={`https://cleartax.in/save/plan/${id}`}
        />
      </div>
    );
  }
}

export default withAppLayout(
  {
    title: 'CleartaxInvest:PlanDetails',
    showElevClick: false,
    hideDefaultCanonical: true,
  },
  PlanDetails
);



// WEBPACK FOOTER //
// ./pages/plan.tsx